export default __webpack_public_path__ + "static/LOVEYOU_YELLOW-0bac1b42bf30f23051ba86dc7f46258e.png";